import React from 'react'
import styled from 'styled-components'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { Button } from '../../UIComponents/StyledButtons'
import { surfaces } from '../../../theme'

const ConfirmationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`

const ConfirmationOverlay = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  background-color: ${themeColors.customOverlayBackground};
  z-index: 9;
`

// Floats like the modals: deep navy, 16px corners, the mint contour and the modal shadow.
const ConfirmationModal = styled.div`
  background-color: ${themeColors.deepblueColor3};
  z-index: 10;
  border-radius: 16px;
  outline: 1px solid ${themeColors.mintBorder};
  outline-offset: -1px;
  box-shadow: ${surfaces.modalShadow};
  cursor: default;
  padding: 2rem 2.5rem;
`

const Text = styled.p`
  color: ${themeColors.whiteColor};
  margin-bottom: 20px;
`

const TitleText = styled(Text)`
  font-weight: 600;
  font-size: 1.8rem;
  text-align: center;
`

const FieldNameText = styled.span`
  color: ${themeColors.mintColor};
  margin-left: 10px;
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const FieldSeasonFormDeletingConfirmationModal = ({ t, onDelete, closeDeletingModal, selectedFieldName }) => {
  return (
    <ConfirmationWrapper data-testid="deletion-confirmation-modal">
      <ConfirmationOverlay onClick={closeDeletingModal} />
      <ConfirmationModal>
        <TitleText>
          {t('Delete field').toUpperCase()}
          <FieldNameText>{selectedFieldName.toUpperCase()}</FieldNameText>
        </TitleText>
        <Text>{t('This action will delete the field and all its related data')}.</Text>
        <ButtonWrapper>
          <Button pill="neutral" onClick={closeDeletingModal} label={t('cancel')} />
          <Button pill="danger" onClick={onDelete} label={t('Delete')} testId="deletion-confirmation-button" />
        </ButtonWrapper>
      </ConfirmationModal>
    </ConfirmationWrapper>
  )
}

export default FieldSeasonFormDeletingConfirmationModal
